import styled from "styled-components/macro";

export const CalendarIconWrapper = styled.div`
  width: ${(props) => props.theme.spacing(10)};
  height: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;
`;
